import { render, staticRenderFns } from "./GInputQuantity.vue?vue&type=template&id=480e0df6"
import script from "./GInputQuantity.vue?vue&type=script&lang=js"
export * from "./GInputQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports